import { Modal, Skeleton } from '@sendible/design-system';
import { useState } from 'react';
import { DaySidebarContent, DaySidebarHeader, MessagesSidebarContent, MessagesSidebarHeader } from './components';

import { useCalendarContext, useCalendarSidebarContext } from '../../context';
import { ErrorBoundary } from '../../../../components';

export const SidebarModal = () => {
  const { closeSidebar } = useCalendarContext();
  const { sidebarMode, sidebarDay, sidebarMessageId, isSidebarOpen } = useCalendarSidebarContext();
  const [hasError, setHasError] = useState(false);

  // ── Render-Phase State Synchronization ──
  // Track structural switches inline to reset error boundaries safely
  const [prevTrackedKeys, setPrevTrackedKeys] = useState(() => ({ sidebarDay, sidebarMessageId, isSidebarOpen }));

  if (
    sidebarDay !== prevTrackedKeys.sidebarDay ||
    sidebarMessageId !== prevTrackedKeys.sidebarMessageId ||
    isSidebarOpen !== prevTrackedKeys.isSidebarOpen
  ) {
    setPrevTrackedKeys({ sidebarDay, sidebarMessageId, isSidebarOpen });
    setHasError(false);
  }

  const renderHeading = () => {
    if (!isSidebarOpen) {
      return (
        <Skeleton
          height="4.875rem"
          width="100%"
        />
      );
    }

    if (hasError) {
      return undefined;
    }

    if (sidebarMode === 'day') {
      return <DaySidebarHeader />;
    }

    return <MessagesSidebarHeader />;
  };

  return (
    <Modal
      data-testid="calendar-sidebar-modal"
      close={closeSidebar}
      variation="right"
      animation="right"
      portalDomId="layer-root"
      headingTitle={renderHeading()}
    >
      {!isSidebarOpen ? (
        <>
          <Skeleton
            height="4.875rem"
            width="100%"
          />
          <Skeleton
            height="4.875rem"
            width="100%"
          />
        </>
      ) : sidebarMode === 'day' ? (
        <ErrorBoundary
          key={sidebarDay}
          translationNamespace="calendar"
          onError={() => setHasError(true)}
        >
          <DaySidebarContent />
        </ErrorBoundary>
      ) : (
        <ErrorBoundary
          key={sidebarMessageId}
          translationNamespace="calendar"
          onError={() => setHasError(true)}
        >
          <MessagesSidebarContent />
        </ErrorBoundary>
      )}
    </Modal>
  );
};
